import React from 'react'
import Style from './users.module.css'

const ConfirmDialog = ({ title, message, confirmLabel, isDanger, isBusy, onConfirm, onCancel }) => (
    <div className={Style.dialogOverlay} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
        <div className={Style.dialog}>
            <div className={Style.dialogHeader}>
                <h3 id="confirm-title" className={Style.dialogTitle}>{title}</h3>
            </div>
            <div className={Style.dialogBody}>
                <p>{message}</p>
            </div>
            <div className={Style.dialogFooter}>
                <button type="button" className={Style.ghostButton} disabled={isBusy} onClick={onCancel}>Cancel</button>
                <button
                    type="button"
                    className={isDanger ? Style.dangerButton : Style.primaryButton}
                    disabled={isBusy}
                    onClick={onConfirm}
                >
                    {isBusy ? 'Working...' : confirmLabel}
                </button>
            </div>
        </div>
    </div>
)

export default ConfirmDialog
